<template>
<div>
    <Breadcrumb :title="'Input Control'"></Breadcrumb>
    <div>
        <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class="btnDiv">
        <BaseToolBar :config="ToolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
        <InputControlForm :ref="'InputControlForm'" :InputControlInfo="InputControlJSON" :InputControlModalLabel="modalConfig"></InputControlForm>
    </div>
    <div>
        <BaseGrid :config="GridConfig" :mode="'editform'" @EditItem="EditInputControl" @DeleteItem="DeleteInputControl"></BaseGrid>
    </div>
</div>
</template>

<script>
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import { ToolbarConfig, GridConfig } from "./InputControlConfig.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import InputControlForm from "@/components/forms/InputControlForm.vue";
import funcUtil from "@/services/funcUtil.js";
import toolbarUtility from "@/services/toolbarUtility.js";
import { mapGetters, mapActions } from 'vuex';

export default {
    name: "InputControl",
    components: {
        Breadcrumb,
        BaseGrid,
        InputControlForm,
        BaseToolBar,
        BaseSearchBar
    },
    mixins: [funcUtil, toolbarUtility],
    data: function () {
        return {
            GridConfig: GridConfig,
            modalConfig: {
                modalName: "",
                modalAddorEdit: ""
            },
            ToolbarConfig: ToolbarConfig,
            search: {
                SearchData: "",
            },
            InputControlJSON: {},
            InputControlMasterData: {},
            InputControlGridId:"InputControlGrid"
        };
    },
    computed: {
        ...mapGetters("getModule", ["withFilter"])
    },
    methods: {
        ...mapActions("postModule",['DeleteItem']),
        EditInputControl(e) {
            let self = this;
            e.preventDefault();
            this.modalConfig.modalName = "Edit Input Control";
            this.modalConfig.modalAddorEdit = "edit";
            var gview = window.$("#"+self.InputControlGridId).data("kendoGrid");
            var dataItem = JSON.parse(JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr"))));
            this.$refs.InputControlForm.pageErrors = [];
            self.InputControlJSON = dataItem;
            window.$("#BaseModal").modal("toggle");
        },
        DeleteInputControl(e){
            let self=this;
            e.preventDefault();
            const message = "Are you sure you want to delete this record?";
            this._ConfirmationPopup(message, "DELETE").then(result => {
                if (result.value) {
                //let loader = this.$loading.show();
                self._APICrudPopup("APICrudpopup");
                let gview = window.$("#"+self.InputControlGridId).data("kendoGrid");
                let dataItem = gview.dataItem(
                    window.$(e.currentTarget).closest("tr")
                );
                let deleteData = { Id: dataItem.Id };
                let ItemsToBeDeleted = { list:GridConfig, payload:deleteData }
                this.DeleteItem(ItemsToBeDeleted).then(response => {
                    $("#"+self.InputControlGridId).data().kendoGrid.dataSource.read();
                    this._AlertPopup("Deleted successfully!","success");
                }).catch(error=>{
                    this._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                   // loader.hide();
                })
                }
            });
        },
        filterGrid(e) {
            let self = this;
            var currentMasterdata = this.InputControlMasterData;
            let filteredData = this._filterGrid(
                this.InputControlMasterData,
                this.search.SearchData
            );
            //Filter by a column
            $("#"+self.InputControlGridId).data("kendoGrid").dataSource.data(filteredData);
            this.UpdateInputControlMasterData(true, currentMasterdata);    
        },
        toolbarOnClick(e) {
            e.preventDefault();
            switch (e.id) {
                case "btnAddInputControl":
                    this.AddInputControl();
                    window.$("#BaseModal").modal("toggle");
                    break;
                default:
                   break; 
            }
            this._baseToolBarEvents(this.InputControlGridId, ...arguments);
        },
        AddInputControl: function () {
            this.modalConfig.modalName = "Add InputControl";
            this.modalConfig.modalAddorEdit = "add";
            let InputControlAddJSON = {
                Id: null,
                Field:"",
                Option:""
            };
            this.$refs.InputControlForm.pageErrors = [];
             this.$refs.InputControlForm.bDisableFields=false;
            this.InputControlJSON = InputControlAddJSON;
        },
        UpdateInputControlMasterData: function(fromFilter, filterMasterData) {
            let self=this;
            if (fromFilter == true) {
                self.InputControlMasterData = filterMasterData;
            } else {
                self.InputControlMasterData = JSON.parse(JSON.stringify($("#"+self.InputControlGridId).data().kendoGrid.dataSource.data()));
            } 
            self.gridColumnNonEditable();
        },
    gridColumnNonEditable: function() {
      var grid = $("#InputControlGrid").data("kendoGrid");

      if (grid.tbody.find("tr").length) {
        grid.tbody.find("tr").each(function() {
          // console.log($(this));

          let dataItem = grid.dataItem(this);
          if (dataItem.ReadOnly == "Yes") {
            if ($(this).find("td").length) {
              // console.log($(this));

              $(this)
                .find("td")
                .each(function(index) {
                  if (index == 0) {
                    $(this).addClass("disableRowCells");
                  }
                });
            }
          }
        });
      }
    }
    },
    mounted() {
        let self=this;
        self._loadGridSettings(self.InputControlGridId);

        //bind databound event to grid
        // self.grid.bind("dataBound", self.UpdateIssuanceMasterData);
        let grid = $("#"+self.InputControlGridId).data("kendoGrid");
        
        grid.bind("dataBound", self.UpdateInputControlMasterData);
        grid.dataSource.fetch();
        
        setTimeout(function(){
           $("#" + self.InputControlGridId).data("kendoGrid").dataSource.read();
       },400)
      
          
    },
}
</script>

<style>
</style>
